export const countries: Array<{ code: string; name: string }> = [
  { code: 'BY', name: 'Беларусь' },
  { code: 'UA', name: 'Украина' },
  { code: 'RU', name: 'Россия' },
  { code: 'PL', name: 'Польша' },
  { code: 'DE', name: 'Германия' },
  { code: 'NL', name: 'Нидерланды' },
  { code: 'BE', name: 'Бельгия' },
];
